import { z } from "zod";

export const zAttrFormulaCell = z.object({
  view: z.literal("AttrFormulaCell"),
});
export type ZAttrFormulaCell = z.infer<typeof zAttrFormulaCell>;
